module.exports = __webpack_public_path__ + "img/nurse.da0b547a.webp";